/**
 * Rarity/quality icon URLs for card display.
 * Prefer card.rarity.value.icon.url from API; fallback to static CMS URLs (from .tmp/bin/Icons.html).
 */
const RARITY_FALLBACK_URLS = {
  common: 'https://cmsassets.rgpub.io/sanity/images/dsfx7636/game_data_live/a088ae851d94b5c34aa4900e8ccb4cc103144dce-354x354.png',
  uncommon: 'https://cmsassets.rgpub.io/sanity/images/dsfx7636/game_data_live/808205a0f070e479107a7655e622fe15a356275b-480x410.png',
  rare: 'https://cmsassets.rgpub.io/sanity/images/dsfx7636/game_data_live/d90078e1ec2ef7cbcbba2be86da1b192c389581a-429x425.png',
  epic: 'https://cmsassets.rgpub.io/sanity/images/dsfx7636/game_data_live/5e9799d87d0f8baa55f6d9bddb9750669a0f485b-455x419.png',
  showcase: 'https://cmsassets.rgpub.io/sanity/images/dsfx7636/game_data_live/a0e92b9edf3291fa62c9b35ffd6363de0d7947c0-376x426.png',
  legendary: 'https://cmsassets.rgpub.io/sanity/images/dsfx7636/game_data_live/d90078e1ec2ef7cbcbba2be86da1b192c389581a-429x425.png'
};

/**
 * Get rarity/quality icon URL for a card. Uses API icon when present, else fallback by rarity label.
 */
export function getRarityIconUrl(card) {
  if (!card) return null;
  const fromApi = card.rarity?.value?.icon?.url;
  if (fromApi) return fromApi;
  const label = (card.rarity?.value?.label || card.rarity || 'common').toLowerCase().replace(/\s/g, '-');
  const key = label.replace(/-/g, '_');
  return RARITY_FALLBACK_URLS[key] ?? RARITY_FALLBACK_URLS.common;
}
